import GlobalSearchContextProvider from 'contexts/GlobalSearch/GlobalSearchContextProvider'
import useGlobalSearchContext from 'hooks/GlobalSearch/useGlobalSearchContext'
import React from 'react'
import OffersLoader from './OffersLoader'

interface Props extends React.ComponentProps<typeof OffersLoader> {}

export default function OffersLoaderWithSearchContext(props: Props) {
  const { globalSearchState, globalSearchDispatch } = useGlobalSearchContext()

  return (
    <GlobalSearchContextProvider state={globalSearchState} dispatch={globalSearchDispatch}>
      <OffersLoader {...props} />
    </GlobalSearchContextProvider>
  )
}
